document.addEventListener("algolia.hooks.initialize", function () {
  // Preload Stamped script on collection pages so badge stars appear faster
  if (
    window.location.pathname.includes("/collections/") &&
    !document.querySelector('script[src*="stamped.io/files/widget.min.js"]')
  ) {
    const script = document.createElement("script");
    script.src = "https://cdn1.stamped.io/files/widget.min.js";
    script.async = true;
    script.setAttribute("data-stamped-preload", "1");
    document.body.appendChild(script);
  }

  // Declare viewedProducts globally
  let viewedProducts = [];

  // Function to get a cookie by name
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  // Function to set a cookie
  const setCookie = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    // Ensure the Secure; SameSite=Lax is added for modern browser compatibility iOS fix
    document.cookie = `${name}=${
      value || ""
    }${expires}; path=/; Secure; SameSite=Lax`;
  };

  // Function to initialize viewedProducts from the cookie
  const initializeViewedProducts = () => {
    const cookie = getCookie("recently_viewed_products");
    if (cookie) {
      try {
        viewedProducts = JSON.parse(cookie);
      } catch (error) {
        console.error("Error parsing cookie:", error);
        viewedProducts = [];
      }
    }
  };

  // Function to add a product to the recently viewed list
  const addRecentlyViewedProduct = (productId, productHandle) => {
    // Remove existing entry if it exists
    viewedProducts = viewedProducts.filter(
      (product) => product.id !== productId,
    );

    // Add the new product to the start of the array
    viewedProducts.unshift({
      id: productId,
      handle: productHandle,
    });

    // Store only the last 4 viewed products
    viewedProducts = viewedProducts.slice(0, 4);

    // Update the cookie
    setCookie("recently_viewed_products", JSON.stringify(viewedProducts), 30);
  };

  // Initialize viewedProducts on script load
  initializeViewedProducts();
  const productId =
    window.currentProductId ||
    document
      .querySelector("[data-product-viewed-id]")
      ?.getAttribute("data-product-viewed-id");
  const productHandle = document
    .querySelector("[data-product-viewed-handle]")
    ?.getAttribute("data-product-viewed-handle");

  if (productId && productHandle) {
    addRecentlyViewedProduct(productId, productHandle);
  }

  // Function to fetch product data using handle
  async function fetchProductData(productHandle) {
    try {
      const productResponse = await fetch(`/products/${productHandle}.json`);
      if (!productResponse.ok) {
        throw new Error("Network response was not ok for product data");
      }
      const productData = await productResponse.json();
      // console.log('productData:::', productData);
      // Had to do this to get stamped metafield
      const metafieldsResponse = await fetch(
        `/products/${encodeURIComponent(productHandle)}?view=metafields`,
      );
      if (!metafieldsResponse.ok) {
        throw new Error("Network response was not ok for metafields");
      }
      const metafieldsData = await metafieldsResponse.json();

      // Check if metafieldsData.metafields is not empty and does not contain null values
      const isValidMetafields =
        metafieldsData.metafields.stamped.badge &&
        Object.keys(metafieldsData.metafields.stamped.badge).length > 0 &&
        !Object.values(metafieldsData.metafields.stamped.badge).includes(null);

      const combinedData = {
        ...productData.product,
        metafields: isValidMetafields
          ? metafieldsData.metafields
          : {
              stamped: {
                badge: "",
              },
            },
      };

      return combinedData;
    } catch (error) {
      console.error("Failed to fetch product data and metafields:", error);
      return null;
    }
  }

  // Function to generate product HTML
  function generateProductHTML(product) {
    const productVariant = product.variants[0];
    const isOnSale =
      productVariant.compare_at_price &&
      productVariant.compare_at_price > productVariant.price;

    // Get badges for this product
    const productId = String(product.id);
    const allBadges = window.AB_BADGE_MAP
      ? window.AB_BADGE_MAP[productId] || []
      : [];
    const specialEnabled = !!window.AB_SPECIAL_EVENTS_ENABLED;

    const visibleBadges = allBadges.filter((badge) => {
      if (!badge.enable_on_collection_pages) return false;
      if (badge.enable_on_special_events_only && !specialEnabled) return false;
      return true;
    });

    let badgesHTML = "";
    visibleBadges.forEach((badge) => {
      const text = badge.text || "Badge";
      if (badge.image) {
        badgesHTML += `<span class="product-label product-label--custom">
          <img src="${badge.image}" alt="${text}" loading="lazy" style="height: 1em; vertical-align: middle;">
        </span>`;
      } else {
        const styles = [];
        if (badge.background_color)
          styles.push(`background-color:${badge.background_color}`);
        if (badge.font_color) styles.push(`color:${badge.font_color}`);
        badgesHTML += `<span class="product-label product-label--custom" style="${styles.join(
          ";",
        )}">${text}</span>`;
      }
    });

    return `
      <div class="old-product product-item product-item--vertical 1/4--lap 1/5--desk 1/6--wide is-selected" >
        <div class="product-item__label-list">
          ${badgesHTML}
          ${
            isOnSale
              ? '<span class="product-label product-label--on-sale">Sale</span>'
              : ""
          }
        </div>
        <a href="/products/${
          product.handle
        }" class="product-item__image-wrapper">
          <div class="aspect-ratio" style="padding-bottom: 100.0%">
            <img class="product-item__primary-image image--fade-in lazyautosizes lazyloaded" fetchpriority="low" loading="lazy" alt="${
              product.title
            }" 
            data-srcset="${product.images
              .map(
                (img, index) =>
                  `${img.src.replace(".jpg", `_${400 + index * 100}x.jpg`)} ${
                    400 + index * 100
                  }w`,
              )
              .join(", ")}"
            sizes="242px" src="${product.images[0].src}">
            <noscript>
              <img src="//alternativebrewing.com.au/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_600x.gif" alt="${
                product.title
              }">
            </noscript>
          </div>
        </a>
        <div class="product-item__info">
          <div class="product-item__info-inner">
            <a class="product-item__vendor link" href="/collections/${
              product.vendor
            }" title="${product.vendor}">${product.vendor}</a>
            <a href="/products/${
              product.handle
            }" class="product-item__title text--strong link">${product.title}</a>
            <!-- Stamped - Begin Star Rating Badge -->
          <span 
            class="stamped-product-reviews-badge" 
            data-id="${product.id}" 
            data-product-sku="${product.handle}" 
            data-product-title="${product.title}" 
            data-product-type="${product.type}" 
            style="display: block;">
            ${product.metafields.stamped.badge}
            </span>
            <!-- Stamped - End Star Rating Badge -->
            <div class="product-item__price-list price-list">
              <span class="price price--highlight">
                <span class="visually-hidden">Sale price</span>$${
                  productVariant.price
                }
              </span>
              ${
                isOnSale
                  ? `<span class="price price--compare">
                <span class="visually-hidden">Regular price</span>$${productVariant.compare_at_price}
              </span>`
                  : ""
              }
            </div>
          </div>
        </div>
      </div>
    `;
  }

  const mediaQuery = window.matchMedia("(max-width: 768px)");
  // Main function to render recently viewed products
  window.renderRecentlyViewedProducts = async function () {
    const container = document.getElementById("recently-viewed-algolia");
    if (!container) {
      console.error("Container for recently viewed products not found.");
      return;
    }
    container.innerHTML = ""; // Clear existing content

    const productPromises = viewedProducts
      .slice(0, 4)
      .map((product) => fetchProductData(product.handle));
    const products = await Promise.all(productPromises);

    products.forEach((product) => {
      if (product) {
        const productHTML = generateProductHTML(product);
        container.insertAdjacentHTML("beforeend", productHTML);
      }
    });
    if (window.matchMedia("(max-width: 768px)").matches) {
      new SimpleBar(document.getElementById("recently-viewed-algolia"), {
        autoHide: false,
      });
    }
  };

  window.renderBadge = async function (handle, html) {
    const container = document.querySelector(
      `.badge-container[data-product-handle="${handle}"]`,
    );
    if (container) {
      container.innerHTML = html;
    }
  };
  // ===== Custom metaobject badges =====
  function attachBadgesToItem(item) {
    if (!window.AB_BADGE_MAP || !Object.keys(window.AB_BADGE_MAP).length) {
      return item;
    }

    let productId = item.product_id || item.id || "";

    if (!productId && item.objectID) {
      productId = item.objectID;
    }

    productId = String(productId);
    if (productId.includes("/")) {
      productId = productId.split("/").pop();
    }

    if (!productId) return item;

    const allBadges = window.AB_BADGE_MAP[productId] || [];
    if (!allBadges.length) return item;

    const specialEnabled = !!window.AB_SPECIAL_EVENTS_ENABLED;

    const visibleBadges = allBadges.filter((badge) => {
      if (!badge.enable_on_collection_pages) return false;
      if (badge.enable_on_special_events_only && !specialEnabled) return false;
      return true;
    });

    if (visibleBadges.length) {
      item.abBadges = visibleBadges;
    }

    return item;
  }

  let openedByFocus = false;

  // Function to modify the text content of the active filter links
  function modifyActiveFilterText() {
    document
      .querySelectorAll(".ais-Panel-body .ais-current-refined-values--link div")
      .forEach((div) => {
        if (div.textContent.includes(";")) {
          const newText = div.textContent.split(";")[0];
          div.textContent = newText;
        }
      });
  }

  function observeDynamicContent() {
    const observer = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      for (const mutation of mutations) {
        if (
          mutation.type === "childList" &&
          mutation.addedNodes.length > 0 &&
          mutation.target.parentElement?.className == "ais-Panel-body"
        ) {
          shouldUpdate = true;
          break;
        }
      }
      if (shouldUpdate) {
        modifyActiveFilterText();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  observeDynamicContent();

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteOptions",
    function (options) {
      const { createLocalStorageRecentSearchesPlugin } =
        window["@algolia/autocomplete-plugin-recent-searches"];
      // Create the recent searches plugin
      const recentSearchesPlugin = createLocalStorageRecentSearchesPlugin({
        key: "RECENT_SEARCH",
        limit: 10,
        transformSource({ source, onRemove }) {
          return {
            ...source,
            templates: {
              ...source.templates,
              item(params) {
                const { item, html } = params;
                return html`<a class="aa-ItemLink" href="/search/?q=${item.id}">
                  ${source.templates.item(params).props.children}
                </a>`;
              },
            },
          };
        },
      });

      options.plugins.push(recentSearchesPlugin);
      options.placeholder = "Search from Australia's largest direct range...";
      options.openOnFocus = true;
      options.detachedMediaQuery = "";
      options.onStateChange = function ({ state }) {
        if (state.isOpen && state.query.length == 0) {
          openedByFocus = true;
        }
        if (state.isOpen && state.query.length > 0) {
          openedByFocus = false;
        }
      };

      return options;
    },
  );

  window.minPrice = 1;
  window.maxPrice = 1000000;

  window.populateRange = function () {
    const container = document.querySelector("#price-range-container-wrapper");
    if (!container) return;

    // Clear previous content
    container.innerHTML = "";

    // Create the slider container
    const sliderContainer = document.createElement("div");
    sliderContainer.id = "price-range-slider";
    container.appendChild(sliderContainer);

    // Initialize noUiSlider
    noUiSlider.create(sliderContainer, {
      start: [window.minPrice, window.maxPrice],
      connect: true,
      range: {
        min: 0,
        max: 10000,
      },
    });

    sliderContainer.noUiSlider.on("update", function (values, handle) {
      window.minPrice = parseInt(values[0], 10);
      window.maxPrice = parseInt(values[1], 10);
      // Consider debouncing this function if needed
      triggerAutocompleteSearch();
    });

    // Initially hide the slider container
    container.style.display = "none";

    // Find the Algolia form and append the toggle button
    const algoliaForm = document.querySelector(".aa-Form");
    if (algoliaForm) {
      const toggleButton = document.createElement("button");
      toggleButton.textContent = "Select Price Range ▼"; // Initial text with a down arrow
      toggleButton.type = "button"; // Prevent form submission
      toggleButton.classList.add("toggleslider");
      toggleButton.onclick = function () {
        const isHidden = container.style.display === "none";
        container.style.display = isHidden ? "block" : "none";
        toggleButton.textContent = isHidden
          ? "Select Price Range ▲"
          : "Select Price Range ▼";
      };

      // Append the toggle button right after the last element of the form
      algoliaForm.appendChild(toggleButton);
    }
  };

  function triggerAutocompleteSearch() {
    const searchInput = document.querySelector("#autocomplete-0-input");
    if (searchInput) {
      const event = new Event("input", {
        bubbles: true,
        cancelable: true,
      });
      searchInput.dispatchEvent(event);
    }
  }

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTransformResponseHits",
    function (hits, results) {
      return hits.filter(
        (hit) => hit.price >= window.minPrice && hit.price <= window.maxPrice,
      );
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteNoResultsTemplate",
    function (_defaultTemplate, templateOptions) {
      const { html, state } = templateOptions;
      return html`
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle"
                  >${algoliaShopify.translations.suggestions}</span
                >
                <span class="no-results">No Results</span>
              </div>
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle"
                  >${algoliaShopify.translations.collections}</span
                >
                <span class="no-results">No Results</span>
              </div>
            </div>
            <div class="aa-PanelSection--right">
              <div class="aa-SourceHeader">
                <span class="aa-SourceHeaderTitle"
                  >${algoliaShopify.translations.products}</span
                >
                <span class="no-results">No Results</span>
              </div>
            </div>
          </div>
        </div>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteMainTemplate",
    function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
      const { html, state } = templateOptions;

      //When user has search history and view history
      if (
        openedByFocus &&
        viewedProducts.length > 0 &&
        elements.recentSearchesPlugin
      ) {
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--left">
                ${displaySuggestions &&
                html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">Recent Searches</span>
                    <div class="aa-SourceHeaderLine" />
                  </div>
                  ${elements.recentSearchesPlugin}
                `}
              </div>
              <div class="aa-PanelSection--right">
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"> Recently Viewed </span>
                  <div class="aa-SourceHeaderLine"></div>
                </div>
                <div id="recently-viewed-algolia"></div>
                <script>
                  renderRecentlyViewedProducts();
                </script>
              </div>
            </div>
          </div>
        `;
      }
      //no searches but viewed products
      if (
        openedByFocus &&
        viewedProducts.length > 0 &&
        !elements.recentSearchesPlugin
      ) {
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--right">
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"> Recently Viewed </span>
                  <div class="aa-SourceHeaderLine"></div>
                </div>
                <div id="recently-viewed-algolia"></div>
                <script>
                  renderRecentlyViewedProducts();
                </script>
              </div>
            </div>
          </div>
        `;
      }

      //no searches no viewed products
      if (
        openedByFocus &&
        viewedProducts.length == 0 &&
        !elements.recentSearchesPlugin
      ) {
        return html` <div class="aa-PanelLayout aa-Panel--scrollable"></div> `;
      }

      //When user has search history and no view history
      if (
        openedByFocus &&
        viewedProducts.length == 0 &&
        elements.recentSearchesPlugin
      ) {
        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable">
            <div class="aa-PanelSections">
              <div class="aa-PanelSection--left">
                ${displaySuggestions &&
                html`
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">Recent Searches</span>
                    <div class="aa-SourceHeaderLine" />
                  </div>
                  ${elements.recentSearchesPlugin}
                `}
              </div>
            </div>
          </div>
        `;
      }

      return html`
        <div id="price-range-container-wrapper"></div>
        <script>
          //populateRange();
        </script>
        <div class="aa-PanelLayout aa-Panel--scrollable">
          <div class="aa-PanelSections">
            <div class="aa-PanelSection--left">
              ${displaySuggestions &&
              html`
                <div class="aa-SourceHeader">
                  <span class="aa-SourceHeaderTitle"
                    >${algoliaShopify.translations.suggestions}</span
                  >
                  <div class="aa-SourceHeaderLine" />
                </div>
                ${elements.querySuggestionsPlugin}
              `}
              ${elements.collections} ${elements.articles} ${elements.pages}
              ${elements.redirectUrlPlugin}
            </div>
            <div class="aa-PanelSection--right">${elements.products}</div>
          </div>
        </div>
        <script>
          if (window.matchMedia("(max-width: 768px)").matches) {
            new SimpleBar(
              document.getElementById("autocomplete-0-products-list"),
              { autoHide: false },
            );
          }
        </script>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      const { html, item, components } = templateOptions;
      attachBadgesToItem(item);
      const isOnSale =
        item.compare_at_price && item.compare_at_price > item.price;
      const stampedMetafield = item.meta?.stamped?.badge ?? "";

      return html`
        <a
          href="${itemLink}"
          class="aa-ItemLink aa-ProductItem"
          onClick="${() => algoliaShopify.helpers.handleItemClick(item)}"
        >
          <div class="old-product product-item product-item--vertical">
            <div class="product-item__label-list">
              ${item.abBadges && item.abBadges.length
                ? item.abBadges.map((badge) => {
                    const text = badge.text || "Badge";

                    if (badge.image) {
                      return html`
                        <span class="product-label product-label--custom">
                          <img
                            src="${badge.image}"
                            alt="${text}"
                            loading="lazy"
                            style="height: 1em; vertical-align: middle;"
                          />
                        </span>
                      `;
                    }

                    const styles = [];
                    if (badge.background_color) {
                      styles.push(`background-color:${badge.background_color}`);
                    }
                    if (badge.font_color) {
                      styles.push(`color:${badge.font_color}`);
                    }

                    return html`
                      <span
                        class="product-label product-label--custom"
                        style="${styles.join(";")}"
                        >${text}</span
                      >
                    `;
                  })
                : ""}
              ${isOnSale
                ? html`
                    <span class="product-label product-label--on-sale"
                      >Sale</span
                    >
                  `
                : ""}
            </div>

            <div class="product-item__image-wrapper">
              <div class="aspect-ratio" style="padding-bottom: 100.0%">
                <img
                  class="product-item__primary-image "
                  src="${algoliaShopify.helpers.compactImage(item)}"
                  alt="${item.title}"
                />
              </div>
            </div>

            <div class="product-item__info">
              <div class="product-item__info-inner">
                <a
                  class="product-item__vendor link"
                  href="/collections/${item.vendor}"
                  title="${item.vendor}"
                  >${item.vendor}</a
                >

                <div class="aa-ItemContentTitleWrapper">
                  <a
                    href="${itemLink}"
                    class="product-item__title text--strong link"
                  >
                    ${item.title}
                  </a>
                </div>

                <div
                  class="badge-container"
                  data-product-handle="${item.handle}"
                >
                  ${stampedMetafield &&
                  html`
                    <script>
                      renderBadge(
                        ${JSON.stringify(item.handle)},
                        ${JSON.stringify(stampedMetafield)},
                      );
                    </script>
                  `}
                </div>

                <div class="product-item__price-list price-list">
                  <span class="price price--highlight">
                    <span class="visually-hidden">Sale price</span>
                    $${item.price}
                  </span>
                  ${isOnSale
                    ? html`
                        <span class="price price--compare">
                          <span class="visually-hidden">Regular price</span>
                          $${item.compare_at_price}
                        </span>
                      `
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </a>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchOptions",
    function (options) {
      // Loop through the facet widgets
      const widgets = options.facets.widgets.map((widget) => {
        // Check if the widget is the refinement list for the 'meta.custom.base_colour' attribute.
        if (
          widget.name === "refinementList" &&
          widget.params.attribute === "meta.custom.base_colour"
        ) {
          // Customize the rendering of the refinement list items for colors.
          const customTemplates = {
            item: function (hit) {
              const isRefined = hit.isRefined ? "isRefined" : "";
              const color = hit.label.split(";")[1];
              const id = `color-${hit.label.split(";")[0]}`;

              return `
            <input
              type="checkbox"
              class="hidden"
              id="${id}"
              ${hit.isRefined ? "checked" : ""}
            />
            <span
              class="color-swatch ${isRefined}"
              style="background-color: ${color}"
            ></span>
          `;
            },
          };

          // Update the widget with custom templates.
          return {
            ...widget,
            params: {
              ...widget.params,
              limit: 15,
              templates: customTemplates,
            },
          };
        }

        // Customize the hierarchical category refinement list
        else if (
          widget.name === "refinementList" &&
          widget.params.attribute === "meta.custom.categories_hierarchical"
        ) {
          // Custom rendering for hierarchical categories
          const customTemplates = {
            item: function (hit) {
              const isRefined = hit.isRefined ? "isRefined" : "";
              const categoryData = JSON.parse(hit.label); // Parse the JSON string
              const lvl0 = categoryData.meta.hierarchical_collection.lvl0;
              const lvl1 = categoryData.meta.hierarchical_collection.lvl1;

              // We've removed the checkbox from the template
              return `
            <div class="ais-RefinementList-item ${isRefined}">
              <label class="ais-RefinementList-label">
                <span class="lvl0">${lvl0}</span> > <span class="lvl1">${lvl1}</span>
                <span class="ais-RefinementList-count">${hit.count}</span>
              </label>
            </div>
          `;
            },
          };

          // Update the widget with custom templates for hierarchical categories.
          return {
            ...widget,
            params: {
              ...widget.params,
              templates: customTemplates,
            },
          };
        } else if (
          widget.name === "refinementList" &&
          widget.params.attribute != undefined
        ) {
          const customTemplates = {
            item: function (hit) {
              const isRefined = hit.isRefined ? "isRefined" : "";

              return `
            <div class="ais-RefinementList-item ${isRefined}">
              <label class="ais-RefinementList-label">
                ${hit.label}
                <span class="ais-RefinementList-count">(${hit.count})</span>
              </label>
            </div>
          `;
            },
          };

          return {
            ...widget,
            params: {
              ...widget.params,
              templates: customTemplates,
            },
          };
        }

        // Return other widgets unchanged.
        return widget;
      });

      return {
        ...options,
        facets: {
          ...options.facets,
          widgets,
        },
      };
    },
  );

  // Add the collection description to the page
  async function fetchCollectionDescription(collectionId) {
    try {
      const collectionResponse = await fetch(
        `/collections/${collectionId}.json`,
      );
      if (!collectionResponse.ok) {
        throw new Error("Network response was not ok for collection data");
      }
      const collectionData = await collectionResponse.json();
      const collectionDescription = collectionData.collection.description;

      // Inject the collection description into the page
      const container = document.querySelector(
        ".container-collection-description .rte",
      );
      if (container) {
        container.innerHTML = collectionDescription;
      }
    } catch (error) {
      console.error("Failed to fetch collection data:", error);
      return null;
    }
  }

  const collection = window.collection;
  if (collection) {
    const collectionHandle = collection.handle;

    if (collectionHandle && collectionHandle !== "all") {
      fetchCollectionDescription(collectionHandle);
    }
  }

  algoliaShopify.hooks.registerHook("beforeISStartAddWidgetArray", function () {
    const { infiniteHits } = window.instantsearch.widgets;

    const containerStaticContent = document.querySelector(".static-content");

    if (containerStaticContent) {
      function addYoutubeImage() {
        const youtubeImage = `
          <div class="card__section videos-subscribe">
            <div id="fresh-coffee-container">
              <a href="https://www.youtube.com/channel/UCNCg231F4jeJ6DjjcYv0MGg?sub_confimation=1" target="_blank" rel="noopener">
                <img class="lazy" data-src="https://cdn.shopify.com/s/files/1/0542/1344/3783/files/Youtube-Subscribe-Reviews-Button-3.jpg?v=1761924191" alt="Subscribe to AlternativeBrewing Channel" src="https://cdn.shopify.com/s/files/1/0542/1344/3783/files/Youtube-Subscribe-Reviews-Button-3.jpg?v=1761924191">
              </a>
            </div>
          </div>
        `;
        containerStaticContent.insertAdjacentHTML("beforeend", youtubeImage);
      }

      // We're making sure that the Stamped script will be loaded only after the stamped-badges container is added to the page
      function loadStampedScript() {
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = "https://cdn1.stamped.io/files/widget.min.js";
          script.async = true;

          script.onload = () => {
            if (typeof StampedFn !== "undefined") {
              resolve();
            } else {
              reject("StampedFn is not defined");
            }
          };

          script.onerror = () => reject("Failed to load Stamped script");
          document.body.appendChild(script);
        });
      }

      function initializeStamped() {
        StampedFn.init({
          apiKey: "pubkey-J7430C9opxwrbIf70979IzK1hzOI0N",
          sId: "191520",
        });
      }

      // Observer to monitor changes in the container, waiting for the stamped-badges container to be added to the page
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              // Check if the stamped-badges container has been added to the page
              if (node.nodeType === 1 && node.matches(".stamped-badges")) {
                // Load the Stamped script and initialize it
                loadStampedScript()
                  .then(initializeStamped)
                  .catch((error) => console.error(error));

                // Disconnect the observer once the script has been loaded and initialized
                observer.disconnect();
              }
            });
          }
        });
      });

      // Start observing the container for child node additions
      const observerConfig = { childList: true, subtree: true };
      observer.observe(containerStaticContent, observerConfig);

      // Insert the HTML content that contains the stamped badges
      containerStaticContent.insertAdjacentHTML(
        "afterbegin",
        `
        <div class="card__section stamped-badges">
          <div>
            <a href="https://alternativebrewing.com.au/pages/reviews">
              <div id="stamped-reviews-widget" data-widget-type="site-badge"></div>
            </a>
          </div>
        </div>
      `,
      );

      addYoutubeImage();
    }

    const infiniteHitsWidget = infiniteHits({
      container: ".ais-hits-container",
      templates: {
        item(hit, { html, components }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchProductTemplate(
            hit,
            html,
            components,
            window.algoliaShopify,
          );
        },
        empty(results, { html }) {
          return window.algoliaShopify.instantsearch.templates.instantSearchNoResultTemplate(
            html,
            window.algoliaShopify,
          );
        },
        showMoreText(data, { html }) {
          // For some reason, "data" is empty here, so we're using CSS to target the disabled button and hide it
          return html`<span>Load more</span>`;
        },
      },
      transformItems: (items) => {
        const transformedItems = items.map((item) => ({
          ...item,
          _distinct: window.algoliaShopify.instantsearch.distinct,
          queryID: item.__queryID,
          productPosition: item.__position,
          index:
            window.algoliaShopify.instantsearch.search.mainIndex.getIndexName(),
        }));
        return transformedItems;
      },
    });

    // Load Stamped and call loadBadges() when Algolia hits render (so collection product badges show correct reviews from Stamped)
    (function ensureStampedBadgesOnCollection() {
      const STAMPED_CONFIG = {
        apiKey: "pubkey-J7430C9opxwrbIf70979IzK1hzOI0N",
        sId: "191520",
      };
      function loadStampedScriptIfNeeded() {
        if (typeof window.StampedFn !== "undefined") {
          return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = "https://cdn1.stamped.io/files/widget.min.js";
          script.async = true;
          script.onload = () =>
            typeof window.StampedFn !== "undefined"
              ? resolve()
              : reject(new Error("StampedFn not defined"));
          script.onerror = () => reject(new Error("Failed to load Stamped"));
          document.body.appendChild(script);
        });
      }
      function initStampedIfNeeded() {
        if (typeof window.StampedFn !== "undefined") {
          window.StampedFn.init(STAMPED_CONFIG);
        }
      }
      function observeHitsContainerAndLoadBadges() {
        const container = document.querySelector(".ais-hits-container");
        if (container) {
          setupBadgeObserver(container);
          return;
        }
        let done = false;
        const waitObserver = new MutationObserver(() => {
          if (done) return;
          const el = document.querySelector(".ais-hits-container");
          if (el) {
            done = true;
            waitObserver.disconnect();
            setupBadgeObserver(el);
          }
        });
        waitObserver.observe(document.body, { childList: true, subtree: true });
      }
      function setupBadgeObserver(container) {
        const runLoadBadges = () => {
          if (
            typeof window.StampedFn !== "undefined" &&
            typeof window.StampedFn.loadBadges === "function"
          ) {
            window.StampedFn.loadBadges();
          }
        };
        const isNewAlgoliaHits = (mutation) => {
          if (mutation.type !== "childList" || !mutation.addedNodes.length)
            return false;
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains("ais-hit"))
              return true;
            if (node.querySelector && node.querySelector(".ais-hit"))
              return true;
          }
          return false;
        };
        const observer = new MutationObserver((mutations) => {
          const hasNewHits = mutations.some(isNewAlgoliaHits);
          if (hasNewHits) runLoadBadges();
        });
        observer.observe(container, { childList: true, subtree: true });
        runLoadBadges();
      }
      loadStampedScriptIfNeeded()
        .then(() => {
          initStampedIfNeeded();
          observeHitsContainerAndLoadBadges();
        })
        .catch(() => {});
    })();

    return [infiniteHitsWidget];
  });

  algoliaShopify.hooks.registerHook(
    "afterISStartRemoveDefaultWidget",
    function (defaultWidgets) {
      // Find 'ais.hits'
      const hitsWidget = defaultWidgets.find(
        (widget) => widget.$$widgetType === "ais.hits",
      );
      // Find 'ais.pagination'
      const paginationWidget = defaultWidgets.find(
        (widget) => widget.$$widgetType === "ais.pagination",
      );

      return [hitsWidget, paginationWidget];
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchFiltersString",
    function (defaultFilter) {
      if (defaultFilter && defaultFilter.includes("collection_ids")) {
        const collectionIDFilterRegex = /collection_ids:"\w+"/g;
        const matches = window.location.pathname.match(
          /\/collections\/([^/]+)/i,
        );
        const collectionHandle =
          matches && matches.length === 2 ? matches[1] : null;
        if (collectionHandle) {
          return defaultFilter.replace(
            collectionIDFilterRegex,
            "collections:" + collectionHandle,
          );
        }
      }
      return defaultFilter;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchProductTemplate",
    function (_defaultTemplate, hit, html, components) {
      attachBadgesToItem(hit);

      const isOnSale =
        hit.compare_at_price > 0 && hit.compare_at_price > hit.price;
      const variantsCount = hit.variants_count;
      const productInventory = hit.variants_inventory_count;
      const inventoryPolicy = hit.inventory_policy;
      const canOrder = hit.can_order;
      const inventoryNotTracked = hit.tags.includes("inventory-not-tracked");

      function handleButtonClick(event) {
        const button = event.target;
        event.preventDefault();
        event.stopPropagation();
        if (!button) return;

        const fullIndexName =
          button.dataset.algoliaIndex || "shopify_ABproducts";
        const productPosition = parseInt(button.dataset.algoliaPosition) || 1;
        const queryID = button.dataset.algoliaQueryid || null;
        const objectID = button.dataset.algoliaObjectid || null;
        const productHandle = button.dataset.handle || "";
        const variantID = button.dataset.variantId || null;
        const hasOptions = button.dataset.action === "choose-options";
        const isAddToCart = button.dataset.action === "add-to-cart";

        const userToken = window.AlgoliaAnalytics._userToken || "user-unknown";
        const timestamp = Date.now();

        let productLink = `${window.Shopify.routes.root}products/${productHandle}`;
        if (variantID) productLink += `?variant=${variantID}`;

        if (hasOptions) {
          return;
        } else if (isAddToCart) {
          const analyticsData = {
            index: fullIndexName,
            eventType: "conversion",
            eventName: "Products Added To Cart",
            eventSubtype: "addToCart",
            objectIDs: [objectID],
            queryID: queryID,
            userToken: userToken,
            positions: [productPosition],
            timestamp: timestamp,
          };

          if (window.algoliaShopify.config.analytics_enabled && queryID) {
            try {
              window.algoliaShopify.sendAnalyticsEventData(
                analyticsData.objectIDs,
                analyticsData.index,
                analyticsData.eventType,
                analyticsData.eventName,
                {
                  userToken: analyticsData.userToken,
                  authenticatedUserToken: analyticsData.userToken,
                  timestamp: analyticsData.timestamp,
                  queryID: analyticsData.queryID,
                  positions: analyticsData.positions,
                  eventSubtype: analyticsData.eventSubtype,
                },
              );
            } catch (error) {
              console.error("Error sending analytics data:", error);
            }
          }

          document.dispatchEvent(new CustomEvent("theme:loading:start"));

          fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: variantID, quantity: 1 }),
          })
            .then((response) => response.json())
            .then((data) => {
              document.dispatchEvent(new CustomEvent("theme:loading:end"));
              button.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: { variant: variantID, quantity: 1 },
                }),
              );
            })
            .catch((error) => {
              console.error("Error adding item to cart:", error);
            });
        }
      }

      return html`
        <div
          class="ais-hit ais-product"
          data-algolia-index="${hit.index}"
          data-algolia-position="${hit.productPosition}"
          data-algolia-queryid="${hit.queryID}"
          data-algolia-objectid="${hit.objectID}"
          data-handle="${hit.handle}"
          data-variant-id="${hit.objectID}"
          data-distinct="${hit._distinct}"
          data-product-id="${hit.id}"
          data-has-options="${hit.hasOptions || false}"
          onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
        >
          <a
            data-algolia-index="${hit.index}"
            data-algolia-position="${hit.productPosition}"
            data-algolia-queryid="${hit.queryID}"
            data-algolia-objectid="${hit.objectID}"
            href="${algoliaShopify.helpers.instantsearchLink(hit)}"
            onclick="void(0)"
            title="${algoliaShopify.helpers.fullTitle(
              hit.title,
              hit._distinct,
              hit.variant_title,
            )}"
          >
            <img
              class="ais-hit--picture"
              src="${algoliaShopify.helpers.mediumImage(hit)}"
              alt="${hit.title} - ${hit.variant_title}"
            />
          </a>

          <div class="product-item__label-list">
            ${hit.abBadges && hit.abBadges.length
              ? hit.abBadges.map((badge) => {
                  const text = badge.text || "Badge";

                  if (badge.image) {
                    return html`
                      <span class="ab:w-6!">
                        <img
                          src="${badge.image}"
                          alt="${text}"
                          loading="lazy"
                        />
                      </span>
                    `;
                  }
                  const styles = [];
                  if (badge.background_color) {
                    styles.push(`background-color:${badge.background_color}`);
                  }
                  if (badge.font_color) {
                    styles.push(`color:${badge.font_color}`);
                  }

                  return html`
                    <span
                      class="ais-product-label ais-product-label--custom"
                      style="${styles.join(";")}"
                      >${text}</span
                    >
                  `;
                })
              : ""}
            ${isOnSale &&
            html`
              <span class="ais-product-label product-label--on-sale">Sale</span>
            `}
          </div>

          <div class="ais-hit--details">
            <div class="ais-hit--details-head">
              <p class="ais-hit--title">
                <a
                  class="ais-hit--title-link"
                  data-algolia-index="${hit.index}"
                  data-algolia-position="${hit.productPosition}"
                  data-algolia-queryid="${hit.queryID}"
                  data-algolia-objectid="${hit.objectID}"
                  href="${algoliaShopify.helpers.instantsearchLink(hit)}"
                  onclick="void(0)"
                  title="${algoliaShopify.helpers.fullTitle(
                    hit.title,
                    hit._distinct,
                    hit.variant_title,
                  )}"
                >
                  ${hit.title}
                </a>
              </p>
              <!-- Stamped - Begin Collection Star Rating Badge (reviews from Stamped, not metafields) -->
              <span
                class="stamped-product-reviews-badge"
                data-id="${(() => {
                  const id = hit.product_id ?? hit.id;
                  if (typeof id === "number") return String(id);
                  if (typeof id === "string" && id.includes("/"))
                    return id.split("/").pop();
                  return id;
                })()}"
                data-product-sku="${hit.handle}"
                data-product-type="${hit.type}"
                data-product-title="${hit.title}"
                style="display:block;"
              >
              </span>
              <!-- Stamped - End Star Rating Badge -->

              <p class="ais-hit--price">
                <b>
                  ${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}
                </b>

                ${hit.compare_at_price > 0 &&
                html`
                  <span class="ais-hit--price-striked">
                    <span>
                      ${algoliaShopify.helpers.displayStrikedPrice(
                        hit.price,
                        hit.compare_at_price,
                      )}
                    </span>
                  </span>
                `}
              </p>
            </div>

            ${hit._distinct &&
            html`
              <div class="ais-hit--details-body">
                <p class="ais-hit--cart">
                  ${productInventory > 0 ||
                  inventoryPolicy === "continue" ||
                  inventoryNotTracked ||
                  canOrder
                    ? html`
                        ${(productInventory <= 0 &&
                          inventoryPolicy === "continue") ||
                        variantsCount > 1
                          ? html`
                              <button
                                class="ais-hit--options-button"
                                data-action="choose-options"
                                data-handle="${hit.handle}"
                                data-variant-id="${hit.objectID}"
                              >
                                <a
                                  href="/products/${hit.handle}"
                                  class="ais-hit--cart-button"
                                  >Choose Options</a
                                >
                              </button>
                            `
                          : html`
                              <button
                                class="ais-hit--cart-button"
                                data-algolia-index="${hit.index}"
                                data-algolia-position="${hit.productPosition}"
                                data-algolia-queryid="${hit.queryID}"
                                data-algolia-objectid="${hit.objectID}"
                                data-handle="${hit.handle}"
                                data-variant-id="${hit.objectID}"
                                data-distinct="${hit._distinct}"
                                data-product-id="${hit.id}"
                                data-action="add-to-cart"
                                onClick="${() => handleButtonClick(event)}"
                              >
                                Add to cart
                              </button>
                            `}
                      `
                    : html`
                        <button
                          disabled
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
              </div>
            `}
          </div>
        </div>
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchStatsTemplate",
    function (_defaultTemplate, data, html) {
      if (data.nbHits) {
        const nbHits = document.querySelector(".nb-hits");
        if (nbHits) {
          nbHits.textContent = `${algoliaShopify.helpers.formatNumber(
            data.nbHits,
          )} `;
        }
      }
      return html`
        ${data.hasOneResult &&
        html`
          <span class="ais-stats--nb-results">
            <strong>1</strong> product
          </span>
        `}
        ${data.hasManyResults &&
        html`
          <span class="ais-stats--nb-results">
            <strong
              >${" "} ${algoliaShopify.helpers.formatNumber(data.nbHits)}
              ${" "}</strong
            >
            products
          </span>
        `}
      `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeInstantSearchMainTemplate",
    function (_defaultTemplate, data, html) {
      const pageType = window.theme.pageType;
      var searchQuery =
        window.algoliaShopify?.instantsearch?.search?.renderState
          ?.shopify_ABproducts?.searchBox?.query ?? null;
      var searchPageTitle = null;

      if (searchQuery == null) {
        const searchInput = document.querySelector(
          '.menu-search-input[name="q"]',
        );
        if (searchInput) {
          searchQuery = searchInput.value;
          if (searchQuery != "") {
            searchPageTitle = `Search results for "${searchQuery}"`;
            // Inject search page title into the breadcrumbs
            const emptyBreadcrumbs = document.getElementById(
              "search-dynamic-breadcrumb",
            );
            if (emptyBreadcrumbs) {
              emptyBreadcrumbs.innerHTML = searchPageTitle;
            }
          }
        }
      }

      function closeFacetsDrawer() {
        const facetsDrawer = document.querySelector(".ais-facets");
        const facetsButton = document.querySelector(".ais-facets-button");
        const body = document.querySelector("body");

        if (facetsDrawer && facetsButton) {
          if (facetsDrawer.classList.contains("ais-facets__shown")) {
            facetsDrawer.classList.remove("ais-facets__shown");
            facetsButton.textContent = "Filter By";
            body.classList.remove("filter-drawer-is-open");
          }
        }
      }

      function showBackgroundOverlay() {
        const body = document.querySelector("body");
        if (body) {
          body.classList.add("filter-drawer-is-open");
        }
      }

      return html`
      <div class="ais-page">
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>

        <div class="ais-facets bordered">
          <div class="facets-header hidden-mobile-and-up">
            <div class="facets-header__heading">FILTER BY</div>
            <span onClick="${() =>
              closeFacetsDrawer()}" class="btn-close-facets-drawer">
              <svg focusable="false" viewBox="0 0 14 14" role="presentation">
                <g fill-rule="nonzero" stroke="#677279" stroke-width="1" fill="none" stroke-linecap="square">
                  <path d="M11.89949494 2L2 11.89949494M1.99999906 2l9.89949494 9.89949494"></path>
                </g>
              </svg>
            </span>
          </div>
          <hr class="border-separator hidden-lap-and-up"></hr>

          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>

          <div class="ais-facets-container">
            ${data.facets.map(
              (facet) =>
                html`
                  <div
                    class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                  >
                    <div class="facet-label-header">
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}
                        <svg focusable="false" class="icon icon--arrow-bottom" viewBox="0 0 12 8" role="presentation">
                          <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>
                        </svg>
                        <svg focusable="false" class="icon icon--top d-none" viewBox="0 0 12 8" role="presentation">
                          <path stroke="currentColor" stroke-width="2" d="M2 6L6 2l4 4" fill="none" stroke-linecap="square"></path>
                        </svg>
                      </label>
                    </div>
                    <input
                      class="ais-dropdown-checkbox"
                      type="checkbox"
                      id="${facet.escapedName}"
                      name="dropdown"
                    />
                    <div
                      class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                    ></div>
                    <hr class="border-separator hidden-lap-and-up"></hr>
                  </div>
                `,
            )}
          </div>
          <div class="facets-footer hidden-lap-and-up">
            <button onClick="${() =>
              closeFacetsDrawer()}">View <span class="nb-hits"></span>products</button>
          </div>
          <div class="static-content hidden-pocket"></div>
        </div>

        <div class="ais-block">
          ${
            pageType === "collection" &&
            window.collection &&
            html`
              <h1 class="algolia-page-title heading h1">
                ${window.collection.title}
              </h1>
            `
          }

          ${
            pageType === "search" &&
            html`
              <h1 class="algolia-page-title heading h1">
                ${searchPageTitle
                  ? searchPageTitle
                  : algoliaShopify.translations.searchTitle}
              </h1>
            `
          }

          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>

            <div class="search-actions">
              <div class="search-action ais-facets-button" onClick="${() =>
                showBackgroundOverlay()}">
                Filter By
              </div>

              <div class="search-action ais-sort">
                ${
                  data.multipleSortOrders
                    ? html` <span class="ais-sort-orders-container"></span> `
                    : html` ${algoliaShopify.translations.relevance} `
                }
              </div>
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>

          <div class="ais-pagination-container"></div>

          <div class="container-collection-description">
            <div class="collection__description">
              <div class="rte">
              </div>
            </div>
          </div>

          <div class="section-faq d-none">
            <div class="category-faq-tab">
              <div class="faq" itemscope="" itemtype="http://schema.org/FAQPage">
                  <h3>Frequently Asked Questions</h3>
                  <div class="faq__group-list" id="faq-container">
                    
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    },
  );

  algoliaShopify.hooks.registerHook(
    "beforeRecommendHitTemplate",
    function (_defaultTemplate, html, item) {
      console.log("hello from recommend hit template");
      return html`
        <div
          id="${item.objectID}"
          class="card-wrapper product-card-wrapper underline-links-hover"
        >
          <div
            class="card test card--standard card--media"
            style="--ratio-percent: 100%;"
          >
            <div
              id="Card--${item.objectID}"
              class="card__inner gradient ratio"
              style="--ratio-percent: 100%"
            >
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a
                      id="StandardCardNoMediaLink--${item.objectID}"
                      class="full-unstyled-link"
                      aria-labelledby="StandardCardNoMediaLink--${item.objectID} NoMediaStandardBadge--${item.objectID}"
                    >
                      ${item.title}
                    </a>
                  </h3>
                </div>
                <div class="card__badge bottom left"></div>
              </div>
            </div>
          </div>
        </div>
      `;
    },
  );
});

// Function to add the collection FAQ to the page
function addCollectionFAQ(faqQuestionsJson, faqAnswersJson) {
  const faqSection = document.querySelector(".section-faq");
  const faqContainer = document.getElementById("faq-container");

  if (!faqContainer) {
    console.warn("FAQ container not found.");
    return;
  }

  if (faqSection && faqQuestionsJson) {
    faqQuestionsJson.forEach((question, index) => {
      const faqItem = document.createElement("div");
      faqItem.className = "faq__item";
      faqItem.setAttribute("itemprop", "mainEntity");
      faqItem.setAttribute("itemscope", "");
      faqItem.setAttribute("itemtype", "http://schema.org/Question");

      const faqItemWrapper = document.createElement("div");
      faqItemWrapper.className = "faq__item-wrapper";

      const button = document.createElement("button");
      button.className = "faq__question heading h4";
      button.setAttribute("data-action", "toggle-collapsible");
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-controls", `block-${index}`);

      const questionHeading = document.createElement("h4");
      questionHeading.setAttribute("itemprop", "name");
      questionHeading.innerText = question;

      button.appendChild(questionHeading);

      const answerWrapper = document.createElement("div");
      answerWrapper.id = `block-${index}`;
      answerWrapper.className = "faq__answer-wrapper";
      answerWrapper.setAttribute("itemscope", "");
      answerWrapper.setAttribute("itemprop", "acceptedAnswer");
      answerWrapper.setAttribute("itemtype", "https://schema.org/Answer");

      const answerContent = document.createElement("div");
      answerContent.className = "faq__answer rte";
      answerContent.setAttribute("itemprop", "text");

      answerContent.innerHTML = faqAnswersJson[index];

      answerWrapper.appendChild(answerContent);

      faqItemWrapper.appendChild(button);
      faqItemWrapper.appendChild(answerWrapper);
      faqItem.appendChild(faqItemWrapper);

      faqContainer.appendChild(faqItem);
    });

    faqSection.classList.remove("d-none");
  }
}

// Set up a MutationObserver to monitor the DOM for the FAQ container
const observer = new MutationObserver((mutations, obs) => {
  const faqContainer = document.getElementById("faq-container");
  const collection = window.collection;

  if (faqContainer && collection) {
    // Fetch and sanitize your questions and answers
    const faqQuestionsString = collection.metafieldQuestion;
    const faqQuestionsJson = JSON.parse(faqQuestionsString);

    const faqAnswersString = collection.metafieldAnswer;
    const sanitizedFaqAnswersString = faqAnswersString.replace(
      /(?<=<[^>]+)"/g,
      '\\"',
    );
    const faqAnswersJson = JSON.parse(sanitizedFaqAnswersString);

    addCollectionFAQ(faqQuestionsJson, faqAnswersJson);

    obs.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Clicking outside the filter drawer closes the filter drawer
function handleClickOutside(event) {
  const body = document.querySelector("body");
  const openFilterDrawer = document.querySelector(
    ".ais-facets.ais-facets__shown",
  );
  const facetsButton = document.querySelector(".ais-facets-button");

  const isDrawerOpen = body?.classList.contains("filter-drawer-is-open");
  const isClickOutsideDrawer =
    openFilterDrawer && !openFilterDrawer.contains(event.target);
  const isClickOutsideButton = facetsButton && facetsButton !== event.target;

  if (isDrawerOpen && isClickOutsideDrawer && isClickOutsideButton) {
    closeFilterDrawer(openFilterDrawer, facetsButton, body);
  }
}

function closeFilterDrawer(openFilterDrawer, facetsButton, body) {
  if (openFilterDrawer) {
    openFilterDrawer.classList.remove("ais-facets__shown");
  }
  if (facetsButton) {
    facetsButton.textContent = "Filter By";
  }
  if (body) {
    body.classList.remove("filter-drawer-is-open");
  }
}

function toggleArrow(event) {
  let header = event.target.closest(".ais-facet--header");
  if (header) {
    let arrow = header.querySelector(".icon--arrow-bottom");
    if (arrow) {
      arrow.classList.toggle("rotated");
    }
  }
}

// perform several actions on click
document.addEventListener("click", handleClickOutside);
document.addEventListener("click", (event) => {
  handleClickOutside(event);
  toggleArrow(event);
});
